angular.module('homebot.directives')

.directive('navDropdown', ['$rootScope', function($rootScope){
  return {
    restrict: 'A',
    controllerAs: 'navDropdownCtrl',
    bindToController: {
      navDropdown: '@',
    },
    scope: {},

    controller: function(){
      let ctrl = this;

      $rootScope.$on('NavDropdownChange', (event, data) => {
        if(ctrl.navDropdown === data.currentDropdown)
          ctrl.dropdownVisible = true;
        else
          ctrl.dropdownVisible = false;
      });
    },

    link: function($scope, el, attrs, ctrl){
      let $el = $(el);
      let isOpen = false;

      function setupDropdownClose(){
        _.defer(() => {
          $(window).one('click.dropdown', () => {
            $('body').removeClass('spotlight-open');
            $el.fadeOut(200).removeClass('nav-dropdown--open');
            isOpen = false;
          });
        });
      }

      let eventCleanup = $rootScope.$on('NavDropdownChange', (event, data) => {
        if(ctrl.navDropdown === data.currentDropdown && !isOpen){
          $('body').addClass('spotlight-open');
          $el.fadeIn(200).addClass('nav-dropdown--open');
          setupDropdownClose();
          isOpen = true;
        }
      });

      $scope.$on('$destroy', eventCleanup); // removes from $rootScope
    }
  }
}]);
